import * as IconSelector from '../icons';

export const sector = [
    {
        value: null,
        label: 'Sin definir',
        description: 'No se ha definido un sector',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: 'Agricultura',
        label: 'Agricultura',
        description: 'Sector Agricola',
        icon: IconSelector.ParcelIcon,
        color: 'Green'
    },
    {
        value: 'Ganaderia',
        label: 'Ganadería',
        description: 'Sector Ganadero',
        icon: IconSelector.AnimalIcon,
        color: 'LightSalmon'
    },
    {
        value: 'Ambos',
        label: 'Ambos',
        description: 'Sector Agricola y Ganadero',
        icon: IconSelector.AllIcon,
        color: 'Blue'
    }
];
